module.exports = {
  title: 'Animated Logo/QRCode with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-04-03',
  slug: 'empty-qr-code',
  tags: ['skia'],
};
